"use client";

import { Button } from "@/components";
import { getImageURL } from "@/lib";

export const HomePageEstimation = ({ data = {}, slug = "calculator-banner" }) => {
    const { cta, image, title } = data;
    return (
        <section className="estimation__section" id={slug}>
            <div className="custom-container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-10 col-xl-10">
                        <div
                            className="bg__area"
                            style={{
                                backgroundImage: `url(${getImageURL(
                                    image?.src
                                )})`,
                                backgroundSize: "cover",
                                backgroundPosition: "50% 50%",
                                backgroundRepeat: "no-repeat",
                            }}
                        >
                            <div className="section_header">
                                <h3
                                    className="heading fs-48 fw-300 text-white"
                                    dangerouslySetInnerHTML={{
                                        __html: title,
                                    }}
                                />
                            </div>
                            <Button label={cta?.title} href={cta?.url || "#"} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
